import React, { useEffect, useState } from 'react';
import useTranslation from '../../hooks/useTranslation';
import UserItemDelete from '../../containers/AppManagement/FixAppData/UserItemManage/UserItemDelete';

/**
 * 유저 아이템 관리 페이지에서 사용할 테이블 컴포넌트
 *
 * useSchemaUserItems 스키마에 정의된 데이터로 테이블을 작성한다.
 *
 * 마지막 칼럼에 삭제 a태그가 표시된다.
 *
 * @param {{schema: object, rows: object[], loading: boolean, className: string, onDelete: function(row)}} param
 * @returns
 */
const BOTableUserItem = ({ schema, rows, loading, className, onDelete }) => {
  const { t } = useTranslation();

  const [headKey, setHeadKey] = useState([]);
  const [head, setHead] = useState([]);
  const [body, setBody] = useState();

  useEffect(() => {
    setHead(schema?.head || []);
    setHeadKey(schema?.headKey || []);
  }, [schema]);

  useEffect(() => {
    if (rows && schema) {
      setBody(schema?.body(rows));
    }
  }, [schema, rows]);

  const layoutBody = () => {
    if (loading) {
      return (
        <tr>
          <td
            colSpan={head.length}
            style={{ textAlign: 'center', backgroundColor: '#FAFBFC' }}
          >
            {t('table.loading')}
          </td>
        </tr>
      );
    }

    if (body && body.length > 0) {
      return body.map((row) => (
        <tr key={row.key}>
          {headKey.map((e, index) => (
            <td className={`td-${e}`} key={e}>
              {index < headKey.length - 1 ? (
                row[e]
              ) : (
                <UserItemDelete row={row} onClick={() => onDelete(row)} />
              )}
            </td>
          ))}
        </tr>
      ));
    }

    return (
      <tr>
        <td
          colSpan={head.length}
          style={{ textAlign: 'center', backgroundColor: '#FAFBFC' }}
        >
          {t('table.log.empty')}
        </td>
      </tr>
    );
  };

  return (
    <div
      className="table-container"
      style={{
        maxHeight: 'calc(100vh - 130px)',
      }}
    >
      <table className={className}>
        <thead>
          <tr>
            {head.map((i, index) => (
              <th
                key={index}
                className=""
                style={{
                  position: 'sticky',
                  top: '0',
                }}
              >
                {i}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{layoutBody()}</tbody>
      </table>
    </div>
  );
};

export default BOTableUserItem;
